import React, {useEffect, useState} from 'react';
import { GridCell } from '@rmwc/grid';
import classNames from 'classnames';
import {
    createCustomerProductSelection,
    getCustomerProductSelections, updateCustomerProductSelection,
} from '../../actions/customerProductSelections';
import moment from 'moment';
import ProductType from '../../const/productType';
import { CustomerProductSelectionTable } from './CustomerProductSelectionTable';
import {useDispatch, useSelector} from 'react-redux';
import { Typography } from '@rmwc/typography';
import { FormattedMessage } from 'react-intl';
import Loader from '../common/Loader';

export const CustomerProductSelectionRow = ({product, contractId, startDate}) => {
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = React.useState(false);
    const [selectedDatePeriods, setSelectedDatePeriods] = useState([]);
    const customProductSelectionsFetching = useSelector(state => state.customerProductSelections.fetching);

    useEffect(() => {
        if (!isOpen || !product.connectedProduct) {
            return;
        }

        dispatch(getCustomerProductSelections(contractId)).then((resp) => {
            const customerProductSelections = resp.value.data;
            if (customerProductSelections.length === 0) {
                setSelectedDatePeriods([]);
                return;
            }
            let increment = 0;
            if (!startDate) {
                increment = moment().date() < 28 ? 1 : 2;
            }
            const tmpSelections = [];
            const crmId = customerProductSelections.find(
                (item) => item.crmId).crmId;
            const contractProductId = customerProductSelections.find(
                (item) => item.contractProductId).contractProductId;
            for (let i = increment; i <= 11 + increment; i++) {
                const newDate = moment(startDate).add(i, 'M').
                    startOf('month').
                    format('YYYY-MM-DD');
                const previous = customerProductSelections.find(
                    item => item.date === newDate);

                if (previous) {
                    tmpSelections.push({
                        ...previous,
                        type: product.id === previous.productId
                            ? product.productType === ProductType.StockPrice
                                ? ProductType.StockPrice
                                : ProductType.FixedPrice
                            : product.connectedProduct.productType ===
                            ProductType.StockPrice
                                ? ProductType.StockPrice
                                : ProductType.FixedPrice,
                    });
                    continue;
                }
                const newCustomerSelection = {
                    crmId,
                    contractProductId,
                    contractId: contractId,
                    date: newDate,
                    type: product.productType === ProductType.StockPrice
                        ? ProductType.StockPrice
                        : ProductType.FixedPrice,
                    productId: product.id,
                };
                dispatch(createCustomerProductSelection(newCustomerSelection)).
                    then((resp) => {
                        setSelectedDatePeriods([
                            ...tmpSelections,
                            {
                                ...resp.value.data,
                                type: product.id === resp.value.data.productId
                                    ? product.productType ===
                                    ProductType.StockPrice
                                        ? ProductType.StockPrice
                                        : ProductType.FixedPrice
                                    : product.connectedProduct.productType ===
                                    ProductType.StockPrice
                                        ? ProductType.StockPrice
                                        : ProductType.FixedPrice,
                            },
                        ].sort(function(a, b) {
                            return new Date(a.date) - new Date(b.date);
                        }));
                    });

            }
            setSelectedDatePeriods(tmpSelections.sort(function(a, b) {
                return new Date(a.date) - new Date(b.date);
            }));
        });
    }, [isOpen]);

    const onDatePeriodSelect = (data) => {
        data.forEach(item => {
            const previous = selectedDatePeriods.find(x => x.id === item.id);
            if (previous.type !== item.type) {
                dispatch(updateCustomerProductSelection({
                    ...item,
                    productId: product.productType === item.type
                        ? product.id
                        : product.connectedProduct.id,
                }));
            }
        });
        setSelectedDatePeriods([...data]);
    };

    const currentMonthSelection = () => {
        if (selectedDatePeriods.length === 0) {
            return '';
        }
        const currentProductSelection = selectedDatePeriods.find(
            item => item.date === moment().startOf('month').format('YYYY-MM-DD'));

        if (!currentProductSelection) {
            return '';
        }
        let price;

        switch (currentProductSelection.type) {
            case ProductType.StockPrice:
                price = product.productType === ProductType.StockPrice
                    ? `${product.stockMarginal.value} ${product.stockMarginal.unit}`
                    : `${product.connectedProduct.stockMarginal.value} ${product.connectedProduct.stockMarginal.unit}`;
                break;
            default:
                price = product.productType === ProductType.StockPrice
                    ? `${product.connectedProduct.basePrice.value} ${product.connectedProduct.basePrice.unit}`
                    : `${product.basePrice.value} ${product.basePrice.unit}`;
                break;
        }

        return (
            <>
                <span className="capitalize">{moment(
                    currentProductSelection.date).
                    format('MMMM, YYYY')}</span>, {price}
            </>);
    };

    return (
        <>
            <GridCell span={12} className="p-10 mdc-theme--primary"
                      onClick={() => setIsOpen(!isOpen)}>
                <Typography use="subtitle1">
                    <FormattedMessage id="Product.VariableProduct.Title"/>
                    <i className={classNames('icon icon-angle-down p-0 ml-15',
                        isOpen ? 'rotate' : '')}/>
                </Typography>
            </GridCell>
            {customProductSelectionsFetching && (
                <GridCell span={12} className="text-center">
                    <Loader />
                </GridCell>
            )}
            {isOpen && !customProductSelectionsFetching && (
                <>
                    <GridCell span={12} className="contract-info--item--child">
                        <Typography use="subtitle2">
                            {currentMonthSelection()}
                        </Typography>
                    </GridCell>
                    <GridCell span={12} className="contract-info--item--child">
                        <CustomerProductSelectionTable
                            onDatePeriodSelect={onDatePeriodSelect}
                            selectedDatePeriods={selectedDatePeriods}
                            primaryProductId={product.id}
                            primaryProductType={product.type}
                            primaryProductMargin={`${product.stockMarginal.value} ${product.stockMarginal.unit}`}
                            connectedProductId={product.connectedProduct.id}
                            connectedProductMargin={`${product.connectedProduct.stockMarginal.value} ${product.connectedProduct.stockMarginal.unit}`}
                        />
                    </GridCell>
                </>
            )}
        </>
    );
};